import { CompanyAPI } from '@api';

const acceptTerm = async (id) => CompanyAPI.acceptTerm({ term_id: id })
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { acceptTerm };
